// extracted by mini-css-extract-plugin
module.exports = {"title":"title__ZjyU81S4Xvj7z","code":"code__7lrla0XMaBIc6"};